import React from 'react';
import { contactData, navLinks } from '../data/mock';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1A2B3C] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 pb-12 border-b border-white/10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full border-2 border-[#D4AF37] flex items-center justify-center">
                <span className="font-playfair text-[#D4AF37] text-xl font-bold">F</span>
              </div>
              <div className="flex flex-col">
                <span className="font-playfair text-white text-xl tracking-wider">FIJA</span>
                <span className="font-lato text-[#D4AF37] text-xs tracking-widest uppercase">Healthcare Specialist</span>
              </div>
            </div>
            <p className="font-lato text-white/60 text-sm leading-relaxed mb-6">
              Heritage, Innovation, and Heart. A new standard of luxury specialist care across London, Essex, and Kent.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-4">
              <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300">
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-playfair text-white text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {navLinks.filter(link => !link.dropdown).map((link) => (
                <li key={link.id}>
                  <a href={link.href} className="font-lato text-white/60 text-sm hover:text-[#D4AF37] transition-colors duration-300">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Locations */}
          <div>
            <h4 className="font-playfair text-white text-lg mb-6">Our Locations</h4>
            <ul className="space-y-3">
              <li>
                <a href="#locations" className="font-lato text-white/60 text-sm hover:text-[#D4AF37] transition-colors duration-300">
                  London - The Urban Retreat
                </a>
              </li>
              <li>
                <a href="#locations" className="font-lato text-white/60 text-sm hover:text-[#D4AF37] transition-colors duration-300">
                  Essex - The Rayleigh Sanctuary
                </a>
              </li>
              <li>
                <a href="#locations" className="font-lato text-white/60 text-sm hover:text-[#D4AF37] transition-colors duration-300">
                  Kent - The Garden Estate
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-playfair text-white text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#D4AF37] mt-1 flex-shrink-0" />
                <span className="font-lato text-white/60 text-sm">{contactData.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
                <span className="font-lato text-white/60 text-sm">{contactData.phone}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
                <span className="font-lato text-white/60 text-sm">{contactData.email}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-lato text-white/40 text-sm">
            © {currentYear} Fija Healthcare Specialist. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="font-lato text-white/40 text-sm hover:text-[#D4AF37] transition-colors duration-300">
              Privacy Policy
            </a>
            <a href="#" className="font-lato text-white/40 text-sm hover:text-[#D4AF37] transition-colors duration-300">
              Terms of Service
            </a>
            <a href="#" className="font-lato text-white/40 text-sm hover:text-[#D4AF37] transition-colors duration-300">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
